import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { HomeState } from "@/components/PageHome/redux/types";
import { HOME_TYPE } from "@/components/PageHome/api/interface";

const selectHome = (state: RootState): HomeState => state?.home;

export default createDraftSafeSelector(selectHome, (home: HomeState): `${HOME_TYPE}` => home.currentFlow);
